import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { useIntl } from "react-intl";
import { Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { CancelReminderDTO } from '../../models/Reminder/CancelReminderDTO';
import { RemindersFromMaintenancePlanResponseDTO } from '../../models/Reminders/RemindersFromMaintenancePlanResponseDTO';
import { ReminderService } from '../../services/ReminderService';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';
import useValidationSchema, { FieldConfig } from '../Validations';

export type CancelReminderComponentProps = {
    Cancel: (data: RemindersFromMaintenancePlanResponseDTO | null) => void;
    CurrentReminder: RemindersFromMaintenancePlanResponseDTO | null;
    SetCurrentReminder: React.Dispatch<React.SetStateAction<RemindersFromMaintenancePlanResponseDTO | null>>;
    OnClose: () => void;
    IsOpen: boolean;
}

export default function CancelReminderComponent(props: CancelReminderComponentProps) {
    const intl = useIntl();
    const reminderService = new ReminderService();
    const [motive, setMotive] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);


    // Validações (campo, tipo dados, mensagem (pt.json))
    const fields: FieldConfig[] = [
        ["reminderId", "number", "CancelReminderComponent.Validation.ReminderIdRequired"],
        ["motive", "string", "CancelReminderComponent.Validation.MotiveRequired"]
    ];
    const schemaClientValidation = useValidationSchema(fields);

    const CancelReminder = async () => {
        setIsLoading(true);

        const cancelReminder: CancelReminderDTO = {
            reminderId: Number(props.CurrentReminder?.reminderId),
            motive: motive ?? null
        };

        const { error } = schemaClientValidation.validate(cancelReminder);
        if (error) {
            Toast.Show("error", error.details.map(detail => detail.message).join(', '));
            setIsLoading(false);
            return;
        }
        const response = await reminderService.Cancel(cancelReminder);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }
        Toast.Show("success", response.message);
        setIsLoading(false);

        props.Cancel(null);
    };

    return (
        <Dialog open={props.IsOpen} fullWidth={true} maxWidth="xs">
            <DialogTitle textAlign={'center'}>
                {intl.formatMessage({ id: "CancelReminderComponent.Title" })}
            </DialogTitle>

            <DialogContent>
                <Row>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"textArea"}
                        value={motive ?? ''}
                        label={intl.formatMessage({ id: "CancelReminderComponent.Motive" })}
                        readOnly={false}
                        onChange={(motive: string) => setMotive(motive)}
                    />
                </Row>
            </DialogContent>

            <DialogActions className="loginbuttons">
                <ButtonComponent
                    onClick={CancelReminder}
                    className="enteraccount"
                    style={{ width: "97%", borderRadius: "5px", margin: "20px" }}
                    text={intl.formatMessage({ id: "CancelReminderComponent.Button.Cancel" })}
                    loading={isLoading}
                />
                <ButtonComponent
                    onClick={props.OnClose}
                    className="enteraccount"
                    style={{ width: "100%", borderRadius: "5px", margin: "20px" }}
                    text={intl.formatMessage({ id: "CancelReminderComponent.Button.Close" })}
                    loading={isLoading}
                />
            </DialogActions>
        </Dialog>
    );
}